// Reglages du parcours de compte partages par toutes les surfaces (page
// d'invitation web et feuille d'inscription de l'app). Deux ecrans qui envoient
// le meme mail par le meme projet Supabase ne peuvent pas avoir deux cadences.

// Renvoi du code : cale sur la cadence de Supabase, pas choisi librement. Le
// projet est regle a 60 s entre deux mails pour un meme destinataire ("Minimum
// interval per user", verifie en prod le 21/08/2026). Un compteur plus court
// laisse cliquer un bouton que le serveur refusera, et l'erreur ressemble alors
// a une panne d'envoi. Ce reglage-la est le maitre : le changer cote Supabase
// impose de changer cette valeur aussi.
export const RESEND_DELAY_S = 60;

// Longueur du code envoye par mail. Sert a la saisie (verification automatique
// des que le compte est complet) et au wording, jamais a valider a la place du
// serveur.
export const OTP_LENGTH = 6;

// Domaine des adresses pour lesquelles la verification du code demande d'abord
// au serveur (src/lib/demoSignIn.js) avant Supabase. C'est ce qui fait vivre la
// paire fixe du compte de review des stores, qui n'a acces a aucune boite mail.
//
// Sans ce filtre, le code a six chiffres de CHAQUE utilisateur partirait aussi
// vers notre backend avant d'aller a Supabase, pour rien. Le filtre est local et
// ne demande rien au serveur : il ne dit donc pas quelles adresses existent.
export const DEMO_SIGNIN_DOMAIN = '@upscale.li';
